import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadMeldungTerminListStatus: 'idle',
    loadMeldungTerminListError: undefined as any,
    loadMeldungTerminListLastArgs: undefined as any,
    loadMeldungTerminStatus: 'idle',
    loadMeldungTerminError: undefined as any,
    saveMeldungTerminStatus: 'idle',
    saveMeldungTerminError: undefined as any,
    deleteMeldungTerminStatus: 'idle',
    deleteMeldungTerminError: undefined as any,

    meldungTerminList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadMeldungTerminList = createAsyncThunk('meldungTerminSlice/loadMeldungTerminList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().meldungTerminSlice.loadMeldungTerminListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremtermin/?action=gte&MIN_MODULTYPE=2&MAX_MODULTYPE=2&MIN_MODULOBJID=${parentModel.HDR_ID}&MAX_MODULOBJID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungTerminListStatus } = getState().meldungTerminSlice
        return loadMeldungTerminListStatus !== 'pending'
    }
})

export const loadMeldungTermin = createAsyncThunk('meldungTerminSlice/loadMeldungTermin', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremtermin/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungTerminStatus } = getState().meldungTerminSlice
        return loadMeldungTerminStatus !== 'pending'
    }
})

export const saveMeldungTermin = createAsyncThunk('meldungTerminSlice/saveMeldungTermin', async ({ meldungTermin }: any, { rejectWithValue }: any) => {
    let promises = []
    if (meldungTermin?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/ncremtermin/${ meldungTermin?.HDR_ID }/`,
            prepareData(meldungTermin),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/ncremtermin/`,
            prepareData(meldungTermin),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMeldungTerminStatus } = getState().meldungTerminSlice
        return saveMeldungTerminStatus !== 'pending'
    }
})

export const deleteMeldungTermin = createAsyncThunk('meldungTerminSlice/deleteMeldungTermin', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/ncremtermin/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMeldungTerminStatus } = getState().meldungTerminSlice
        return deleteMeldungTerminStatus !== 'pending'
    }
})

const MeldungTerminSlice = createSlice({
    name: 'meldungTerminSlice',
    initialState,
    reducers: {
        resetloadMeldungTerminListError: (state) => {
            state.loadMeldungTerminListError = undefined
        },
        resetloadMeldungTermin: (state) => {
            state.formItem = undefined
            state.loadMeldungTerminError = undefined
        },
        resetloadMeldungTerminError: (state) => {
            state.loadMeldungTerminError = undefined
        },
        resetsaveMeldungTermin: (state) => {
            state.formItem = undefined
            state.saveMeldungTerminError = undefined
        },
        resetsaveMeldungTerminError: (state) => {
            state.saveMeldungTerminError = undefined
        },
        resetdeleteMeldungTerminError: (state) => {
            state.deleteMeldungTerminError = undefined
        },
        removeFromMeldungTerminListById: (state, action) => {
            state.meldungTerminList = state.meldungTerminList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromMeldungTerminListByIds: (state, action) => {
            state.meldungTerminList = state.meldungTerminList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.meldungTerminList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadMeldungTerminListStatus = 'preloaded'
            state.loadMeldungTerminListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.meldungTerminList = []
            state.loadMeldungTerminListStatus = 'idle'
            state.loadMeldungTerminListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMeldungTerminList.pending, (state) => {
            state.loadMeldungTerminListStatus = 'pending'
            state.loadMeldungTerminListError = undefined
        })
        builder.addCase(loadMeldungTerminList.fulfilled, (state, action) => {
            state.loadMeldungTerminListStatus = 'idle'

            if (!action.payload) { return }

            state.loadMeldungTerminListLastArgs = action.payload.args

            {
                state.meldungTerminList = action.payload.data

            }
        })
        builder.addCase(loadMeldungTerminList.rejected, (state, action) => {
            state.loadMeldungTerminListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungTerminListError = action.error.message
            } else {
                state.loadMeldungTerminListError = action.payload
            }
        })

        builder.addCase(loadMeldungTermin.pending, (state) => {
            state.loadMeldungTerminStatus = 'pending'
            state.loadMeldungTerminError = undefined
        })
        builder.addCase(loadMeldungTermin.fulfilled, (state, action) => {
            state.loadMeldungTerminStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungTerminList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungTerminList.push(newItem) }
                else { state.meldungTerminList[i] = { ...state.meldungTerminList[i], ...newItem } }
            }
        })
        builder.addCase(loadMeldungTermin.rejected, (state, action) => {
            state.loadMeldungTerminStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungTerminError = action.error.message
            } else {
                state.loadMeldungTerminError = action.payload
            }
        })

        builder.addCase(saveMeldungTermin.pending, (state) => {
            state.saveMeldungTerminStatus = 'pending'
            state.saveMeldungTerminError = undefined
        })
        builder.addCase(saveMeldungTermin.fulfilled, (state, action) => {
            state.saveMeldungTerminStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungTerminList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungTerminList.push(newItem) }
                else { state.meldungTerminList[i] = { ...state.meldungTerminList[i], ...newItem } }
            }
        })
        builder.addCase(saveMeldungTermin.rejected, (state, action) => {
            state.saveMeldungTerminStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMeldungTerminError = action.error.message
            } else {
                state.saveMeldungTerminError = action.payload
            }
        })

        builder.addCase(deleteMeldungTermin.pending, (state) => {
            state.deleteMeldungTerminStatus = 'pending'
            state.deleteMeldungTerminError = undefined
        })
        builder.addCase(deleteMeldungTermin.fulfilled, (state, action) => {
            state.deleteMeldungTerminStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.meldungTerminList = state.meldungTerminList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.meldungTerminList = state.meldungTerminList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMeldungTermin.rejected, (state, action) => {
            state.deleteMeldungTerminStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMeldungTerminError = action.error.message
            } else {
                state.deleteMeldungTerminError = action.payload
            }
        })

    }
})

export const {
    resetloadMeldungTerminListError,
    resetloadMeldungTermin,
    resetloadMeldungTerminError,
    resetsaveMeldungTermin,
    resetsaveMeldungTerminError,
    resetdeleteMeldungTerminError,
    removeFromMeldungTerminListById,
    removeFromMeldungTerminListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = MeldungTerminSlice.actions
export default MeldungTerminSlice.reducer
